import { DeliveryPackageSourcePickingView } from "src/components/views/erp/delivery/deliveryPackage/picking/DeliveryPackageSourcePickingView.tsx";
import { CustomerOrderLineReservationFormApi } from "src/api/generated/erp/sales/delivery/api/customerOrderLineReservationFormApi.ts";
import { ProjectActivityMaterialReservationFormApi } from "src/api/generated/erp/project/delivery/api/projectActivityMaterialReservationFormApi.ts";
import { PurchaseOrder } from "../../../../../api/generated/erp/db/types/tables/purchaseOrder.ts";
import { WarehousePickingObjectLocationView } from "../../../../../api/generated/erp/db/types/tables/warehousePickingObjectLocationView.ts";
import { DeliveryPackageSource } from "../../../../../api/generated/erp/delivery/model/deliveryPackageSource.ts";

export interface PurchaseOrderSourcePickingViewProps {
	purchaseOrder: PurchaseOrder;
	deliveryPackageSource: DeliveryPackageSource;
}

export const PurchaseOrderSourcePickingView = ({ purchaseOrder, deliveryPackageSource }: PurchaseOrderSourcePickingViewProps) => {
	return (
		<DeliveryPackageSourcePickingView
			deliveryPackageSource={deliveryPackageSource}
			deliverySourceHasAutomaticReservation={false}
			revertReservation={revertReservation}
			purchaseOrderId={purchaseOrder.purchaseOrderId}
		/>
	);

	async function revertReservation({
		pickingObjectLocation,
		quantityToRevertInBaseUnit,
	}: {
		pickingObjectLocation: WarehousePickingObjectLocationView;
		quantityToRevertInBaseUnit: number;
	}) {
		if (deliveryPackageSource.type === "customerOrder") {
			await CustomerOrderLineReservationFormApi.createReservations({
				reservationRequests: [
					{
						customerOrderLineId: pickingObjectLocation.objectId,
						partWarehouseLocationId: pickingObjectLocation.partWarehouseLocationId,
						quantityInWarehouseUnit: -quantityToRevertInBaseUnit,
					},
				],
			});
		} else if (deliveryPackageSource.type === "project") {
			await ProjectActivityMaterialReservationFormApi.createReservations({
				reservationRequests: [
					{
						projectActivityMaterialId: pickingObjectLocation.objectId,
						partWarehouseLocationId: pickingObjectLocation.partWarehouseLocationId,
						quantityInWarehouseUnit: -quantityToRevertInBaseUnit,
					},
				],
			});
		}
	}
};
